(async () => {
  const el = document.getElementById('contacts-content')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/info/contacts.vue'),
    },
  ]

  await clientRender({ components })
})()
